var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('terms-conditions',{attrs:{"wb":_vm.welcomeBack,"campaignId":_vm.baseData.campaignId,"wftkn":_vm.wftkn,"termsData":_vm.baseData.termsConditionModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }